export enum EventTargets {
  Moengage = 'MOE',
  Clickhouse = 'CLICKHOUSE',
  Ems = 'EMS',
  GTM = 'GTM',
  Appsflyer = 'APPSFLYER',
  Facebook = 'FACEBOOK',
  Branch = 'BRANCH',
}
